import styled from 'styled-components';

export const StyledTruncatedTextTooltip = styled.div`
  &.i__tooltip {
    --max-w: 600px;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
`;
